import { Component, OnInit, ViewEncapsulation, OnDestroy } from "@angular/core";

@Component({
    templateUrl: "./maintenance.html",
    encapsulation: ViewEncapsulation.None
})
export class MaintenancePage implements OnInit, OnDestroy {
    ngOnInit(): void {
        const loading = document.getElementById("loading").attributes;
        loading["href"].nodeValue = "assets/css/template/loading.css";
    }

    ngOnDestroy(): void {
        const loading = document.getElementById("loading").attributes;
        loading["href"].nodeValue = "";
    }
}